<template>
  <b-row class="mt-1 mb-5">
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <h3 class="mb-0 border-left custom-header-border">
            <span class="ml-2">{{OverviewSectorData.title}}</span>
          </h3>
        </template>
        <b-row class="m-3 text-light">
          <b-col md="3" cols="12" class="mt-2" v-for="item in OverviewSectorData.content" :key="item.id">
            <b-card bg-variant="info">
              <b-row no-gutters>
                <b-col cols="3" class="text-center">
                  <font-awesome-icon :icon="item.icon" class="text-white mt-4" size="4x"/>
                </b-col>
                <b-col cols="9" class="text-right">
                  <b-card-body :title="item.name">
                    <b-card-text class="h5">{{item.value}}</b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" class="mt-5">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <h3 class="mb-0 border-left custom-header-border">
            <span class="ml-2">{{RemiderSectorData.title}}</span>
          </h3>
        </template>
        <b-row class="m-3 text-light">
          <b-col md="3" cols="12" class="mt-2" v-for="item in RemiderSectorData.content" :key="item.id">
            <b-card bg-variant="info" class="overflow-hidden height-100 border-0">
              <b-row no-gutters>
                <b-col cols="3" class="text-center">
                  <font-awesome-icon :icon="item.icon" class="text-white mt-4" size="4x"/>
                </b-col>
                <b-col cols="9" class="text-right">
                  <b-card-body :title="item.name">
                    <b-card-text class="h5">{{item.value}}</b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" class="mt-5">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">訂單統計</span>
          </div>
          <!--div>
            <b-form-datepicker id="deliver-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="deliver-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setDeliverInterval(-7)" :class="{active:daysBeforeDeliverEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setDeliverInterval(-30)" :class="{active:daysBeforeDeliverEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setDeliverInterval(-60)" :class="{active:daysBeforeDeliverEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="deliversCountDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="deliversCountDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="deliversCountDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="deliversCountDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-row align-v="center">
          <b-col md="2" class="text-center">
            <h4>今日訂單總數</h4>
            <h4>{{deliverGrowthRate.todayCount}}</h4>
            <div v-if="Number.isFinite(deliverGrowthRate.value)">
              <span :class="[deliverGrowthRate.isPositive ? 'text-success' : 'text-danger']">
                <font-awesome-icon v-if="deliverGrowthRate.isPositive" icon="caret-up"></font-awesome-icon>
                <font-awesome-icon v-else icon="caret-down"></font-awesome-icon>
                {{deliverGrowthRate.value}}%
              </span>
              <small>對比昨日</small>
            </div>
          </b-col>
          <b-col md="10">
            <line-chart v-if="deliverChartData" :chart-data="deliverChartData" :options="LineChartOptions"/>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" class="mt-5">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">銷售統計</span>
          </div>
          <!--div>
            <b-form-datepicker id="sell-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="sell-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setSellInterval(-7)" :class="{active:daysBeforeSellEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setSellInterval(-30)" :class="{active:daysBeforeSellEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setSellInterval(-60)" :class="{active:daysBeforeSellEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="sellAmountDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="sellAmountDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="sellAmountDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="sellAmountDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-row align-v="center">
          <b-col md="2" class="text-center">
            <h4>今日銷售總額</h4>
            <h4>{{amountGrowthRate.todayCount}}</h4>
            <div v-if="Number.isFinite(amountGrowthRate.value)">
              <span :class="[amountGrowthRate.isPositive ? 'text-success' : 'text-danger']">
                <font-awesome-icon v-if="amountGrowthRate.isPositive" icon="caret-up"></font-awesome-icon>
                <font-awesome-icon v-else icon="caret-down"></font-awesome-icon>
                {{amountGrowthRate.value}}%
              </span>
              <small>對比昨日</small>
            </div>
          </b-col>
          <b-col md="10">
            <line-chart v-if="sellChartData" :chart-data="sellChartData" :options="LineChartOptions"/>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
import moment from 'moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCalendar,
  faCoins,
  faChartLine,
  faUsers,
  faTruck,
  faBoxes,
  faExclamationCircle,
  faCartArrowDown,
  faCaretUp,
  faCaretDown
} from '@fortawesome/free-solid-svg-icons'
import LineChart from '../../library/LineChart.js'
library.add(faCalendar, faCoins, faChartLine, faUsers, faTruck, faBoxes, faExclamationCircle, faCartArrowDown, faCaretUp, faCaretDown)
export default {
  components: {
    LineChart
  },
  data () {
    return {
      ov: {},
      rd: {},
      // delivers
      endOfDeliverInterval: null,
      daysBeforeDeliverEnd: 0,
      deliverChartData: false,
      // sell
      endOfSellInterval: null,
      daysBeforeSellEnd: 0,
      sellChartData: false,
      deliverGrowthRate: {
        todayCount: 0,
        value: 0,
        isPositive: true
      },
      amountGrowthRate: {
        todayCount: 0,
        value: 0,
        isPositive: true
      }
    }
  },
  computed: {
    OverviewSectorData () {
      return {
        title: '商城概況',
        content: [
          { id: 'o1', name: '本週訂單總數', value: this.ov.o1 || 0, icon: 'calendar' },
          { id: 'o2', name: '本週銷售總額', value: this.ov.o2 || 0, icon: 'coins' },
          { id: 'o3', name: '總瀏覽量', value: this.ov.o3 || 0, icon: 'chart-line' },
          { id: 'o4', name: '本週新會員數', value: this.ov.o4 || 0, icon: 'users' }
        ]
      }
    },
    RemiderSectorData () {
      return {
        title: '提醒事項',
        content: [
          { id: 'r1', name: '待出貨訂單', value: this.rd.r1 || 0, icon: 'truck' },
          { id: 'r2', name: '待取貨訂單', value: this.rd.r2 || 0, icon: 'boxes' },
          { id: 'r3', name: '即將缺貨', value: this.rd.r3 || 0, icon: 'exclamation-circle' },
          { id: 'r4', name: '即將下架', value: this.rd.r4 || 0, icon: 'cart-arrow-down' }
        ]
      }
    },
    LineChartOptions () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 100
            }
          }]
        }
      }
    },
    dailyDeliverIntervalData () {
      let end = moment(this.endOfDeliverInterval)
      let start = moment(end).day(this.daysBeforeDeliverEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    },
    dailySellIntervalData () {
      let end = moment(this.endOfSellInterval)
      let start = moment(end).day(this.daysBeforeSellEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    }
  },
  methods: {
    setDeliverInterval (n = 0) {
      this.daysBeforeDeliverEnd = n
      this.endOfDeliverInterval = moment()
      this.drawDeliversChart()
    },
    async drawDeliversChart () {
      const query = `?${QueryString.stringify(this.dailyDeliverIntervalData)}`
      const { data: array } = await this.$api.GetDailyDeliverCount(query)
      const labels = Object.keys(array)
      const datasets = [{
        label: '訂單統計',
        backgroundColor: '#5ee1c6',
        data: Object.values(array)
      }]
      this.deliverChartData = { labels, datasets }
    },
    setSellInterval (n = 0) {
      this.daysBeforeSellEnd = n
      this.endOfSellInterval = moment()
      this.drawSellChart()
    },
    async drawSellChart () {
      const query = `?${QueryString.stringify(this.dailySellIntervalData)}`
      const { data: array } = await this.$api.GetDailyAmountCount(query)
      const labels = Object.keys(array)
      const datasets = [{
        label: '銷售金額',
        backgroundColor: '#5ee1c6',
        data: Object.values(array)
      }]
      this.sellChartData = { labels, datasets }
    },
    async fetchGrowthRates () {
      const today = moment()
      const yestoday = moment(today).add(-1, 'day')
      const obj = {
        start: yestoday.format('YYYYMMDD'),
        end: today.format('YYYYMMDD')
      }
      const query = `?${QueryString.stringify(obj)}`
      const { data: delivers } = await this.$api.GetDailyDeliverCount(query)
      const { data: amounts } = await this.$api.GetDailyAmountCount(query)
      if (delivers) {
        const [ yestodayDC = 0, todayDC = 0 ] = Object.values(delivers)
        let value = ((todayDC - yestodayDC) / yestodayDC) || 0
        let isPositive = true
        if (value < 0) {
          isPositive = false
          value *= -1
        }
        this.deliverGrowthRate = { todayCount: todayDC, value: value.toFixed(1), isPositive }
      }
      if (amounts) {
        const [ yestodayAC = 0, todayAC = 0 ] = Object.values(amounts)
        let value = ((todayAC - yestodayAC) / yestodayAC) || 0
        let isPositive = true
        if (value < 0) {
          isPositive = false
          value *= -1
        }
        this.amountGrowthRate = { todayCount: todayAC, value: value.toFixed(1), isPositive }
      }
    },
    deliversCountDownloadLink (format) {
      const obj = { format, ...this.dailyDeliverIntervalData }
      const query = `?${QueryString.stringify(obj)}`
      return this.$api.urlDailyDeliverCount(query)

    },
    sellAmountDownloadLink (format) {
      const obj = { format, ...this.dailySellIntervalData }
      const query = `?${QueryString.stringify(obj)}`
      return this.$api.urlDailyAmountCount(query)
    }
  },
  created () {
    // weekly delivers
    this.$api.getCount().then(({data: val}) => this.$set(this.ov, 'o1', val))
    // weekly sell price
    this.$api.getSale().then(({data: val}) => this.$set(this.ov, 'o2', val))
    // weekly view
    this.$api.getViwer().then(({data: val}) => this.$set(this.ov, 'o3', val))
    // weekly new user
    this.$api.getNewUser().then(({data: val}) => this.$set(this.ov, 'o4', val))
    // have credited
    this.$api.getCredited().then(({data: val}) => this.$set(this.rd, 'r1', val))
    // is prepared
    this.$api.getDelivering().then(({data: val}) => this.$set(this.rd, 'r2', val))
    // not enought
    this.$api.getOutofAmount().then(({data: val}) => this.$set(this.rd, 'r3', val))
    // out of date
    this.$api.getOutofDate().then(({data: val}) => this.$set(this.rd, 'r4', val))
    this.setDeliverInterval(-7)
    this.setSellInterval(-7)
    this.fetchGrowthRates()
  }
}
</script>
<style scoped>
  .mw-15 {
    max-width: 15rem;
  }
</style>